import i18n from '@/i18n';
import User from './User';
import Role from './Role';
import Org from './Org';
import Dict from './Dict';
import Commission from './Commission';
import Promotion from './Promotion';
import Log from './Log';
import Resources from './Resources';
import Version from './Version';
import VehicleType from './VehicleType';
import ContentModeration from './ContentModeration'; //$IMPORT$
import OlisSetting from './OlisSetting';

export default () => [
  {
    resourceName: i18n.t('system-index-1992f2b8cf08bbc5c-1'),
    routerUrl: '/system',
    resourceIcon: '',
    type: '0',
    buttons: [],
    children: [
      User(),
      Role(),
      Org(),
      // Dict(),
      Commission(),
      Promotion(),
      OlisSetting(),
      Log(),
      Resources(),
      Version(),
      VehicleType(),
      ContentModeration(), //$MORE$
    ],
  },
];
